export const comCopy = {
  com_layout_title: "TypeScript のセットアップ方法",
  com_layout_description:
    "TypeScriptユーザーとオンライン、オフラインでつながる",
  com_headline: "Connect with us",
  com_connect_online: "オンライン",
  com_connect_online_description:
    "うまくいっていること、新機能や改善点を私たちに教えてください。そして、新しいアップデートを見つけましょう。",
  com_online_stack_overflow_desc:
    "「typescript」タグを使って仲間とつながったり、TypeScriptについての質問をしましょう",
  com_online_stack_overflow_tag: "",
  com_online_discord_header: "チャット",
  com_online_discord_desc:
    "TypeScriptコミュニティのチャットで、他のTypeScriptユーザーとやり取りをしましょう",
  com_online_github_desc:
    "バグや、フィードバックの報告は",
  com_online_github_href: "GitHubで伝えましょう",
  com_online_twitter_desc: "最新情報はTwitterでフォロー",
  com_online_blog_desc:
    "最新のTypeScriptの開発状況は",
  com_online_typed_desc: "Definitely Typedで",
  com_online_typed_href: "多くのライブラリやフレームワーク",
  com_online_typed_available_for:
    "の型定義を利用できます",
  com_person: "人とつながる",
  com_conferences: "カンファレンス",
  com_conferences_alt_img: "ロゴ ",
}
